import type { JSX } from "react";
import { socialLinks } from "@/app/config/info";
import Icon from "../atoms/icon";
import Link from "../atoms/link";
import Text from "../atoms/text";
import View from "../atoms/view";

/**
 * @name Footer
 * @description Renders the application footer with copyright info and social links.
 *
 * @returns {JSX.Element} The rendered footer component.
 */
const Footer = (): JSX.Element => (
  <View
    type="footer"
    className="bg-[#1F2039] text-white py-4 px-6 md:px-12 z-[100] relative mt-auto"
  >
    <View className="flex flex-col md:flex-row justify-between items-center gap-4 max-w-[1920px] mx-auto">
      <View className="flex gap-6 items-center">
        {Object.entries(socialLinks).map(([key, href]) => (
          <Link
            key={key}
            href={href}
            aria-label={key}
            className="hover:text-primary duration-300"
          >
            <Icon name={`${key}:fa:brands`} size="6x" />
          </Link>
        ))}
      </View>
      <View className="flex items-center gap-3">
        <Icon name="envelope" size="4x" />
        <Text className="text-sm md:text-base font-medium">
          portalansvmesa@seguridadvial.gob.ar
        </Text>
      </View>
    </View>
  </View>
);

export default Footer;
